/**
 * 나이 표기. 입력은 출생연도(또는 민감정보의 생년월일)로 받고, 문서에는 기록 날짜 기준으로 계산한다.
 * 생년월일이 없으면 생일 전후를 알 수 없으므로 만 나이를 범위로 정직하게 쓴다.
 */
export function ageText(opts: { birthYear?: number; birthDate?: string; on: string }): string | undefined {
  const onY = Number(opts.on.slice(0, 4));
  if (opts.birthDate && /^\d{4}-\d{2}-\d{2}$/.test(opts.birthDate)) {
    const by = Number(opts.birthDate.slice(0, 4));
    const hadBirthday = opts.on.slice(5, 10) >= opts.birthDate.slice(5, 10);
    return `${by}년생 (만 ${onY - by - (hadBirthday ? 0 : 1)}세)`;
  }
  if (opts.birthYear) {
    const y = onY - opts.birthYear;
    return `${opts.birthYear}년생 (만 ${y - 1}~${y}세)`;
  }
  return undefined;
}
